exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".term-info .el-tabs--card > .el-tabs__header .el-tabs__item {\n  width: 178px;\n  border-top: 1px solid #c8d3da;\n}\n.term-info .el-tabs--card .el-tabs__header .el-tabs__nav {\n  border-left: 1px solid #c8d3da !important;\n}\n.term-info .el-tabs__item.is-active,\n.term-info .el-tabs__item:hover {\n  color: #00b3ee;\n}\n.term-info .el-tabs__header .el-tabs__item.is-active:before {\n  background: #00b3ee;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#00b3ee",
	"menuBg": "#1f2d52",
	"minWidth": "1190",
	"minHeight": "669.375",
	"headerHeight": "60",
	"footerHeight": "60",
	"menuText": "#dae3f2",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#00b3ee",
	"sidebarWidth": "200",
	"treeWidth": "340",
	"crumbsHeight": "60"
};